<template>
  <div :class="isAutomationArchive ? 'premium-card-width' : 'flex-fill bg-ashore-white sidebar-padding'"
    class="premium-gate-card d-flex flex-column align-items-start justify-content-center">
    <div v-if="isAutomationArchive" class="badge bg-success-100 text-success-800">{{ WORKFLOWS.badge }}</div>
    <h2 class="title ff-montserrat text-gray-900" v-html="formatTitle(WORKFLOWS.title)"></h2>
    <p class="description">{{ WORKFLOWS.description }}</p>
    <ul class="feature-list text-gray-600" :class="!isAutomationArchive && 'sidebar-margin-bottom'">
      <li v-for="(feature, idx) in WORKFLOWS.features" :key="idx">
        <img src="/img/check-circle.svg" alt="check" class="icon" />
        {{ feature }}
      </li>
    </ul>
    <div class="footer">
      <button class="upgrade-btn bg-success-500" :class="!isAutomationArchive && 'sidebar-upgrade-btn'"
        @click="billingSection">{{ WORKFLOWS.upgradeText }}</button>
      <button class="maybe-btn text-ashore-black" :class="!isAutomationArchive && 'custom-border sidebar-maybe-btn'"
        @click="salesSection">{{ WORKFLOWS.maybeLaterText }}</button>
    </div>
    <newUserWelcomeModal name="NewUserWelcomeModal" />
  </div>
</template>

<script>
import newUserWelcomeModal from '../modals/modal-new-user-welcome.vue';
import { PREMIUM_FEATURE_CONTENT, ROUTES, MODAL_NAMES } from '../../utils/constants';

const { WORKFLOWS } = PREMIUM_FEATURE_CONTENT;
const { BILLING } = ROUTES;

export default {
  name: 'PremiumGateWorkflows',
  components: {
    newUserWelcomeModal
  },
  props: {
    isAutomationArchive: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      WORKFLOWS
    }
  },
  methods: {
    formatTitle(title) {
      if (!title) return '';
      return title.replace(/\{([^}]+)\}/g, '<span class="text-success-500">$1</span>');
    },
    salesSection() {
      this.$bvModal.show(MODAL_NAMES.NEW_USER_MODAL);
    },
    billingSection() {
      this.$router.push(BILLING)
    }
  }
};
</script>

<style scoped>
.premium-gate-card {
  background: var(--Ashore-Colors-White, #F9F9F9);
  border-radius: 10px;
  padding: 48px;
  font-family: 'Open Sans', sans-serif;
  color: #374151;
  gap: 16px;
  align-self: stretch;
}

.sidebar-padding {
  padding: 32px 48px !important;
}

.premium-card-width {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 2px 24px rgba(0, 0, 0, 0.08);
  width: 1200px;
  margin: 40px auto;
}

.badge {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  display: inline-block;
  font-weight: 400;
  line-height: 16px;
}

.title {
  font-size: 30px;
  font-weight: 700;
  margin: 0;
  line-height: 40px;
}

.description {
  font-size: 18px;
  font-weight: 400;
  color: #374151;
  margin: 0;
  line-height: 24px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-bottom: 8px;
}

.sidebar-margin-bottom {
  margin-bottom: 28px;
}

.feature-list li {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 400;
  line-height: 24px;
}

.feature-list li:last-child {
  margin-bottom: 0px;
}

.icon {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.footer {
  display: flex;
  gap: 16px;
  margin: 0;
}

.upgrade-btn {
  color: #F9F9F9;
  padding: 9px 17px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.upgrade-btn:hover {
  background-color: #017a4a;
}

.maybe-btn {
  padding: 9px 17px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  border: none;
  background: transparent;
}

.sidebar-maybe-btn,
.sidebar-upgrade-btn {
  padding: 13px 25px;
}

.custom-border {
  border: 1px solid #B5B5B8;
}
</style>
